var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('dv-decoration-11',{staticStyle:{"width":"100%","height":"40px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }